<template>
  <b>{{$attrs.text.text.hablante}}: </b>
</template>
